<template>
    <!--
        Netsis Bağlantı Durumu LED'i.

        Sidebar'ın sol alt köşesinde küçük bir gösterge. Renk:
          - yeşil: son kontrol başarılı (Netsis erişilebilir)
          - kırmızı: son kontrol başarısız (Netsis'e ulaşılamıyor)
          - gri: henüz kontrol edilmedi / kontrol devam ediyor

        Hover'da tooltip; tıklayınca elle yenileme (refresh=true) yapılıyor.
    -->
    <div class="netsis-status"
         v-b-tooltip.hover.right="tooltipText"
         v-on:click="checkNow"
         :class="stateClass"
         :title="tooltipText">
        <span class="led"></span>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
import { NetsisApi } from '@/api/netsis'

export default {
    directives:{
        'b-tooltip': VBTooltip
    },
    data(){
        return {
            // null: henüz sorulmadı, true: online, false: offline
            isOnline: null,
            message: null,
            checkedAtStr: null,
            responseTimeMs: null,
            loading: false,
            timer: null,
        }
    },
    mounted(){
        this.check()
        // Backend cache 30 sn; istemciyi 60 sn'de bir soralım — sunucu ekstra Netsis çağrısı
        // yapmadan cached değeri döndürür.
        this.timer = setInterval(() => this.check(false), 60_000)
    },
    beforeDestroy(){
        if(this.timer) clearInterval(this.timer)
    },
    methods:{
        check(refresh = false){
            if(this.loading) return
            this.loading = true
            NetsisApi.GetNetsisHealth(refresh).then(res => {
                const d = res?.data || {}
                this.isOnline = d.IsOnline ?? null
                this.message = d.Message
                this.checkedAtStr = d.CheckedAtStr
                this.responseTimeMs = d.ResponseTimeMs
                this.loading = false
            }).catch(() => {
                // API'ye bile ulaşamadıysak (kendi API'miz down): kullanıcıya yeşil demek yanlış olur.
                this.isOnline = false
                this.message = 'API sağlık servisi cevap vermiyor.'
                this.loading = false
            })
        },
        checkNow(){
            // Tıklamada refresh=true — sunucu cache'i atlayıp gerçek çağrı yapar.
            this.check(true)
        }
    },
    computed:{
        stateClass(){
            if(this.loading && this.isOnline === null) return 'state-loading'
            if(this.isOnline === true)  return 'state-online'
            if(this.isOnline === false) return 'state-offline'
            return 'state-unknown'
        },
        tooltipText(){
            const head = 'Netsis: '
                + (this.isOnline === true ? 'Bağlantı sağlıklı'
                : this.isOnline === false ? 'Bağlantı yok'
                : 'Kontrol ediliyor…')
            const parts = [head]
            if(this.message) parts.push(this.message)
            if(this.responseTimeMs != null) parts.push(`Yanıt süresi: ${this.responseTimeMs} ms`)
            if(this.checkedAtStr) parts.push('Son kontrol: ' + this.checkedAtStr)
            parts.push('(Tıklayarak yenileyin)')
            return parts.join('\n')
        }
    }
}
</script>

<style scoped>
.netsis-status {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 8px 0;
    user-select: none;
    transition: transform 0.15s ease;
}
.netsis-status:hover {
    transform: scale(1.15);
}
.led {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #adb5bd;
    box-shadow: 0 0 0 0 rgba(0,0,0,0);
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.state-online .led {
    background: #28c76f;
    box-shadow: 0 0 6px rgba(40, 199, 111, 0.7);
}
.state-offline .led {
    background: #ea5455;
    box-shadow: 0 0 6px rgba(234, 84, 85, 0.7);
    /* offline'da dikkat çekmesi için hafif nabız animasyonu */
    animation: pulse-red 1.6s ease-in-out infinite;
}
.state-loading .led {
    background: #7367f0;
    animation: pulse-blue 1s ease-in-out infinite;
}
.state-unknown .led {
    background: #adb5bd;
}
@keyframes pulse-red {
    0%, 100% { box-shadow: 0 0 6px rgba(234, 84, 85, 0.7); }
    50%      { box-shadow: 0 0 14px rgba(234, 84, 85, 1); }
}
@keyframes pulse-blue {
    0%, 100% { opacity: 1; }
    50%      { opacity: 0.4; }
}
</style>
